import { render } from "./OlabRecipe.vue?vue&type=template&id=29642428&scoped=true"
import script from "./OlabRecipe.vue?vue&type=script&lang=js"
export * from "./OlabRecipe.vue?vue&type=script&lang=js"

import "./OlabRecipe.vue?vue&type=style&index=0&id=29642428&scoped=true&lang=css"

import exportComponent from "/Users/ckyang/dev/olabbio/sites/olab-github/gf-olab-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29642428"]])

export default __exports__